import React, {Component} from 'react';
import moment from 'moment';
import _ from 'lodash';

class DateSelector extends Component {
    constructor(props){
        super(props);
        this.setDate = this.setDate.bind(this);
    }

    setDate(event) {
        const date = moment(this.props.value);
        _.invoke(date, event.target.name, event.target.value);
        this.props.onChange({
            target: {
                name: this.props.name,
                value: date,
            }
        });
    }

    render() {
        const dateValue = this.props.value;

        const yearOptions = [];
        let startingYear = 1900;
        while (startingYear <= moment().year()) { yearOptions.push(startingYear++); }

        const dateOptions = [];
        let startingDate = 1;
        while (startingDate <= 31) { dateOptions.push(startingDate++); }

        return (
            <div className='date-selector form-inline'>
                <select className='custom-select' name='month' value={dateValue.month()} onChange={this.setDate}>
                    {(new Array(12)).fill(0, 0, 12).map((obj, index) =>
                        <option key={index} value={index}>{moment().month(index).format('MMMM')}</option>
                    )}
                </select>
                <select className='custom-select' name='date' value={dateValue.date()} onChange={this.setDate}>
                    {dateOptions.map((date) =>
                        <option key={date} value={date} disabled={!moment([dateValue.year(), dateValue.month(), date]).isValid()}>{date}</option>
                    )}
                </select>
                <select className='custom-select' name='year' value={dateValue.year()} onChange={this.setDate}>
                    {yearOptions.map((year) =>
                        <option key={year} value={year}>{year}</option>
                    )}
                </select>
            </div>
        );
    }
}

export default DateSelector;
